// extracted by mini-css-extract-plugin
module.exports = {"patient-filter-container":"style_patient-filter-container__2mOrj","active":"style_active__1NnQz","load-more-container":"style_load-more-container__1vVK2"};